import React, { useState } from "react";
import { FaEnvelope } from "react-icons/fa";
import logo from "../asset/logowhite.png";
import loginbg from "../asset/login/login.png";
import SummaryApi from "../common";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const StudentMobilenumber = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const isValidEmail = (input) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(input);
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!isValidEmail(email)) {
  //     toast.error("Please enter a valid email address");
  //     return;
  //   }

  //   try {
  //     const response = await fetch(SummaryApi.studentPasswordVerification.url, {
  //       method: SummaryApi.studentPasswordVerification.method,
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ email }),
  //     });

  //     const data = await response.json();

  //     if (data.status) {
  //       localStorage.setItem("student_identifier", email);
  //       localStorage.setItem("student_otp", data.otp);

  //       setTimeout(() => {
  //         navigate("/student-password-otp");
  //       }, 800);
  //     } else {
  //       toast.error(data.message || "Invalid input");
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     toast.error("Something went wrong. Please try again.");
  //   }
  // };
const handleSubmit = async (e) => {
  e.preventDefault();

  if (!isValidEmail(email)) {
    toast.error("Please enter a valid email address");
    return;
  }

  try {
    const response = await fetch(SummaryApi.studentPasswordVerification.url, {
      method: SummaryApi.studentPasswordVerification.method,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });

    const data = await response.json();

    if (data.status) {
      localStorage.setItem("student_identifier", email);
      localStorage.setItem("student_otp", data.otp);

      // Success toast
      toast.success("OTP sent to your email");

      setTimeout(() => {
        navigate("/student-password-otp");
      }, 1000);
    } else {
      toast.error(data.message || "Invalid input");
    }
  } catch (error) {
    console.error("Error:", error);
    toast.error("Something went wrong. Please try again.");
  }
};

  return (
    <div className="min-h-screen w-full bg-white flex items-center justify-center">
      <div className="w-full max-w-7xl min-h-[650px] flex rounded-3xl overflow-hidden shadow-lg">
        {/* Left Side - Background with logo */}
        <div className="w-1/2 relative">
          <img
            src={loginbg}
            alt="student Background"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-30" />
          <div className="relative z-10 flex items-center justify-center h-full">
            <img src={logo} alt="Logo" className="w-64" />
          </div>
        </div>

        {/* Right Side - Form */}
        <div className="w-1/2 bg-white flex items-start justify-center pt-6 px-10">
          <div className="w-full max-w-md">
            {/* Welcome Title */}
            <h2 className="text-[45px] font-bold text-blue-900 mb-6 text-center font-inter">
              Verify Your Account!
            </h2>

            {/* Form */}
            <form className="space-y-6 items-center mt-[20%]" onSubmit={handleSubmit}>
              {/* Email Input */}
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700 font-inter mb-1"
                >
                  Email Address
                </label>
                <div className="relative">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 pl-10"
                    required
                  />
                  <FaEnvelope className="absolute left-3 top-2/4 transform -translate-y-1/2 text-gray-400 text-lg" />
                </div>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full py-3 bg-blue-900 hover:bg-blue-800 text-white font-semibold rounded-lg shadow-md transition duration-200 font-inter"
              >
                NEXT
              </button>
            </form>

            {/* Sign Up Link */}
            <p className="mt-6 text-sm text-center text-gray-600 font-inter">
              Not a member?{" "}
              <a
                href="/student-create"
                className="text-blue-900 font-medium hover:underline font-inter"
              >
                sign up
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Toast Container */}
      <ToastContainer position="top-center" autoClose={3000} />
    </div>
  );
};

export default StudentMobilenumber;
